import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Row } from "ant-design-vue";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { createFieldTextArea } from "../../../../components/input/template-builder/template-builder.logic";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createButtonSave } from "../../../../utils/button";
import { initUseForm, onClickView } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { validateError } from "../../../../utils/validate";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/appProperty";
export const routerPrefix = "maquee-news";

export const callGetMarqueenNews = () => store.dispatch(`${actionPrefix}/getMarqueenNews`, {});
export const callUpdateMarqueenNews = ({ form }) => store.dispatch(`${actionPrefix}/updateMarqueenNews`, { data: form });

export const onClickSave = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callUpdateMarqueenNews({ form: data.useForm.modelRef?.str })
                .finally(() => setIsLoadingApp(false))
                .then(record => onClickView({ record, routerPrefix }));
        })
        .catch(error => validateError({ error }));
};

export const createForm = () => {
    return {
        str: null
    };
};

export const createRules = () => {
    return {
        str: []
    };
};

export const createField = ({ props, data }) => {
    const viewOnly = props.viewOnly;
    const useForm = data.useForm;
    const modelRef = useForm.modelRef;
    return [
        createFieldTextArea({
            key: "str",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("views.marqueeNews.title"),
            inputProp: () => ({ value: modelRef.str, "onUpdate:value": value => (modelRef.str = value), disabled: viewOnly })
        })
    ];
};

export const loadForm = ({ data }) => {
    setIsLoading(true);
    let promise = callGetMarqueenNews().then(str => ({ data: [{ str }] }));
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const createAppPageHeaderDefault = ({ props, data }) => {
    const col1 = [];
    const col2 = [];
    const { viewOnly } = props;
    const { id, isActive } = data.useForm.modelRef;
    if (!viewOnly && (!id || (id && isActive))) {
        col1.push(createButtonSave({ onClick: () => onClickSave({ data }), classStyle: "m-1" }));
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};
